/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { TableCell, TableRow, IconButton, withStyles, Tooltip } from "@material-ui/core";
import { DeleteOutlined, EditOutlined, FileCopyOutlined } from "@material-ui/icons";
import copy from "copy-to-clipboard";
import { getPromptIvrId } from "./utils";

const StyledTableCell = withStyles((_theme) => ({
	root: {
		"&:nth-child(1), &:nth-child(2), &:nth-child(4), &:nth-child(6),": {
			width: "10% !important",
		},
		"&:nth-child(3), &:nth-child(5)": {
			width: "30% !important",
		},
	},
	body: {
		verticalAlign: "middle !important",
		fontSize: 14,
		padding: "10px 24px 10px 16px",
		"& p": {
			whiteSpace: "pre-line",
			margin: 0,
			maxHeight: "180px",
			overflowY: "hidden",
			textOverflow: "ellipsis",
		},
	},
}))(TableCell);

/**
 * Displays a single contact row with select, edit and delete actions
 * @param {Object} props
 * @param {Object} props.contact contact record to display
 * @param {() => void} props.deleteContact function to delete the contact
 * @param {(contactId: string) => any} props.editContact function to edit the contact
 */
const PromptsTableRow = ({ prompt, getConnectPromptName, editPrompt, deletePrompt, showMessage, canDelete }) => {
	const getPromptMessage = () => {
		const promptName = getConnectPromptName(prompt.prompt, prompt.type);
		return (
			<p className="m-0" title={promptName}>
				{promptName}
			</p>
		);
	};

	return (
		<TableRow key={prompt.contactId}>
			<StyledTableCell>{prompt.language}</StyledTableCell>
			<StyledTableCell>{prompt.namespace}</StyledTableCell>
			<StyledTableCell>{prompt.promptId}</StyledTableCell>
			<StyledTableCell>{prompt.type}</StyledTableCell>
			<StyledTableCell>{getPromptMessage()}</StyledTableCell>
			<TableCell align="right">
				<IconButton
					size="small"
					onClick={() => {
						const promptText = getPromptIvrId(prompt);
						copy(promptText);
						showMessage("success", `Copied ${promptText} to clipboard.`);
					}}
				>
					<Tooltip title="Copy full prompt identifier">
						<FileCopyOutlined />
					</Tooltip>
				</IconButton>
				<IconButton size="small" onClick={editPrompt}>
					<Tooltip title="Edit Prompt">
						<EditOutlined />
					</Tooltip>
				</IconButton>
				<IconButton disabled={!canDelete} size="small" color="secondary" onClick={deletePrompt}>
					<Tooltip title="Delete Prompt">
						<DeleteOutlined />
					</Tooltip>
				</IconButton>
			</TableCell>
		</TableRow>
	);
};

export default PromptsTableRow;
